// Espejo de backend/src/config/permisos.ts — mantener ambos sincronizados.
// Sistema de permisos por rol: cada negocio puede decidir, por rol y por
// sección del panel, si esa sección está OCULTA, solo se puede VER, o se
// puede VER y EDITAR (el comportamiento de siempre). El rol ADMIN siempre
// tiene acceso total, sin importar lo que diga este campo — así un negocio
// nunca puede bloquearse a sí mismo por accidente.

export type NivelPermiso = "OCULTO" | "VER" | "EDITAR";
export type PermisosRoles = Record<string, Record<string, NivelPermiso>>;

export const ROLES_PERSONALIZABLES = [
  { value: "VETERINARIO", label: "Veterinario" },
  { value: "RECEPCIONISTA", label: "Recepcionista" },
  { value: "GROOMER", label: "Groomer / Estética" },
  { value: "ENTRENADOR", label: "Entrenador" },
  { value: "PASEADOR", label: "Paseador" },
] as const;

export const SECCIONES = [
  { value: "dashboard", label: "Panel" },
  { value: "clientes", label: "Clientes" },
  { value: "mascotas", label: "Mascotas (incluye expediente clínico)" },
  { value: "agenda", label: "Agenda" },
  { value: "punto-de-venta", label: "Punto de venta" },
  { value: "inventario", label: "Productos y Servicios" },
  { value: "facturacion", label: "Facturación" },
  { value: "recordatorios", label: "Recordatorios" },
  { value: "hospedaje", label: "Hotel / Guardería" },
  { value: "espacios", label: "Espacios" },
  { value: "grooming", label: "Estética" },
  { value: "entrenamiento", label: "Entrenamiento" },
  { value: "domicilio", label: "A domicilio" },
  { value: "paseos", label: "Paseos" },
  { value: "reportes", label: "Reportes" },
  { value: "usuarios", label: "Usuarios" },
  { value: "transferencias", label: "Transferencias" },
  { value: "suscripcion", label: "Suscripción" },
  { value: "configuracion", label: "Configuración" },
  { value: "soporte-tecnico", label: "Soporte técnico" },
] as const;

export function obtenerNivelPermiso(
  permisosRoles: PermisosRoles | null | undefined,
  rol: string | undefined | null,
  seccion: string
): NivelPermiso {
  if (!rol || rol === "ADMIN" || rol === "SUPER_ADMIN") return "EDITAR";
  return permisosRoles?.[rol]?.[seccion] ?? "EDITAR";
}
